export enum TableView {
  WaitingReview,
  WaitingFinalOrder,
  WaitingPayment,
  WaitingSetSchedule,
  Finished
}
